module.exports = __webpack_public_path__ + "static/media/speaker2.9d69a53f.jpg";